import React from 'react'

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9994 3.00052V18.5865L5.7064 13.2935C5.3154 12.9025 4.6834 12.9025 4.2924 13.2935C3.9014 13.6845 3.9014 14.3165 4.2924 14.7075L11.2914 21.7075C11.3844 21.7995 11.4954 21.8725 11.6174 21.9235C11.8614 22.0245 12.1374 22.0245 12.3814 21.9235C12.5034 21.8725 12.6144 21.7995 12.7074 21.7075L19.7064 14.7075C19.9014 14.5125 19.9994 14.2565 19.9994 14.0005C19.9994 13.7445 19.9014 13.4885 19.7064 13.2935C19.3154 12.9025 18.6834 12.9025 18.2924 13.2935L12.9994 18.5865L12.9994 3.00052C12.9994 2.44852 12.5514 2.00052 11.9994 2.00052C11.4474 2.00052 10.9994 2.44852 10.9994 3.00052Z"
      fill="#2E2D37"
    />
  </svg>
)
